export default __webpack_public_path__ + "467e5802931fcc0ba7e1eb11f7f1f8a3.png";